const entryTypeToPathMap = {
    'grantAwarded': 'grants-awarded',
    'news': 'news',
    'event': 'events',
    'featured': 'featured',
    'article': 'publications',
    'project': 'projects'
};

export function generateSliderBlock(entryType, entries, sameEntryType = false) {
    const { t } = useI18n();
    const localePath = useLocalePath();

    let link = [];
    let title = t('related-items.title');

    if (sameEntryType) {
        link = [{
            label: `${t('related-items.read-more')} ` + t(`entry-type.plural.${entryType}`),
            internalLink: localePath(entryTypeToPathMap[entryType] || '/')
        }];

        title = t(`entry-type.plural.${entryType}`);
    }

    return {
        title,
        link,
        entries
    };
}
